import { IconX } from '@tabler/icons-react';

import Button from '@lotlinx-aws/sparky-component-library/Sparky/Button';
import IconButton from '@lotlinx-aws/sparky-component-library/Sparky/IconButton';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';

import styles from './UnsavedChanges.module.scss';

export interface UnsavedChangesProps {
  onStay(): void;
  onLeave(): void;
}

/**
 * UnsavedChanges
 */
export default function UnsavedChanges({ onStay, onLeave }: UnsavedChangesProps) {
  return (
    <div className={styles.unsavedChanges}>
      <IconButton
        aria-label='close modal'
        size='md'
        onClick={onStay}
        className={styles.closeButton}
      >
        <IconX size={14} />
      </IconButton>
      <Text size='20' fontWeight={7} color='primary'>
        You have unsaved changes
      </Text>
      <Text size='16' fontWeight={4}>
        If you leave this page, your changes will be lost
      </Text>
      <div className={styles.buttonsWrapper}>
        <Button variant='outline' onClick={onLeave}>
          Leave, discard changes
        </Button>
        <Button variant='solid' onClick={onStay}>
          Stay, keep editing
        </Button>
      </div>
    </div>
  );
}
